module.exports = __webpack_public_path__ + "static/media/eventingplus.8422d4e6.svg";